import { render, staticRenderFns } from "./AccountLogin.vue?vue&type=template&id=f90c3f68"
import script from "./AccountLogin?vue&type=script&lang=ts&external"
export * from "./AccountLogin?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports